var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.3 27.3",
    style: {
      enableBackground: "new 0 0 27.3 27.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AEB0D4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.3,18.9h4.1v-2.6H7.3c-1.7,0-2.6-0.6-2.6-1.7c0-1.1,0.9-1.7,2.6-1.7h2.3L4.2,4.5C3.8,3.8,3.5,3.3,3.3,3 c-0.1-0.3-0.2-0.6-0.2-1c0-0.6,0.2-1.1,0.6-1.5C4.1,0.2,4.6,0,5.2,0c0.6,0,1.1,0.2,1.5,0.6C7,0.9,7.5,1.5,8,2.4l5.8,9.1L19,2.9 c0.2-0.3,0.4-0.7,0.6-1.1c0.2-0.4,0.4-0.7,0.6-0.9c0.2-0.3,0.5-0.5,0.8-0.6C21.3,0.1,21.7,0,22.1,0c0.6,0,1.1,0.2,1.5,0.5 c0.4,0.4,0.6,0.8,0.6,1.3c0,0.4-0.1,0.8-0.2,1.2c-0.1,0.3-0.4,0.8-0.7,1.3L18,12.9h2.3c1.7,0,2.5,0.6,2.5,1.7 c0,1.1-0.8,1.7-2.5,1.7h-4.1v2.6h4.1c1.7,0,2.5,0.6,2.5,1.7c0,1.1-0.8,1.7-2.5,1.7h-4.1v1.4c0,2.4-0.8,3.7-2.4,3.7 c-1.6,0-2.5-1.2-2.5-3.7v-1.4h-4c-1.7,0-2.6-0.6-2.6-1.7C4.7,19.4,5.6,18.9,7.3,18.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYenIcon);
export default __webpack_public_path__ + "static/media/yen_icon.3a4ea34a72bd650491c71d5b7a171d99.svg";
export { ForwardRef as ReactComponent };